import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';

import Button from '../../../components/ui/Button';

const PerformanceChart = () => {
  const [chartType, setChartType] = useState('line');
  const [dateRange, setDateRange] = useState('7d');

  const performanceData = [
    { date: '01/09', commissions: 2400, bookings: 12, clicks: 340 },
    { date: '02/09', commissions: 1398, bookings: 8, clicks: 280 },
    { date: '03/09', commissions: 9800, bookings: 25, clicks: 520 },
    { date: '04/09', commissions: 3908, bookings: 15, clicks: 410 },
    { date: '05/09', commissions: 4800, bookings: 18, clicks: 380 },
    { date: '06/09', commissions: 3800, bookings: 22, clicks: 450 }
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-popover-foreground mb-2">{`Date: ${label}`}</p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry?.color }}>
              {`${entry?.name}: ${entry?.name === 'commissions' ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })?.format(entry?.value) : 
                entry?.value}`}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-card-foreground">Performance des 7 derniers jours</h3>
        <div className="flex items-center space-x-2">
          <div className="flex bg-muted rounded-lg p-1">
            <Button
              variant={dateRange === '7d' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setDateRange('7d')}
            >
              7j
            </Button>
            <Button
              variant={dateRange === '30d' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setDateRange('30d')}
            >
              30j
            </Button>
            <Button
              variant={dateRange === '90d' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setDateRange('90d')}
            >
              90j
            </Button>
          </div>
          <div className="flex bg-muted rounded-lg p-1">
            <Button
              variant={chartType === 'line' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setChartType('line')}
              iconName="TrendingUp"
              iconSize={16}
            >
            </Button>
            <Button
              variant={chartType === 'bar' ? 'default' : 'ghost'}
              size="sm"
              onClick={() => setChartType('bar')}
              iconName="BarChart3"
              iconSize={16}
            >
            </Button>
          </div>
        </div>
      </div>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          {chartType === 'line' ? (
            <LineChart data={performanceData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis 
                dataKey="date" 
                stroke="var(--color-muted-foreground)"
                fontSize={12}
              />
              <YAxis 
                stroke="var(--color-muted-foreground)"
                fontSize={12}
              />
              <Tooltip content={<CustomTooltip />} />
              <Line 
                type="monotone" 
                dataKey="commissions" 
                stroke="var(--color-accent)" 
                strokeWidth={2}
                name="Commissions"
              />
              <Line 
                type="monotone" 
                dataKey="bookings" 
                stroke="var(--color-success)" 
                strokeWidth={2}
                name="Réservations"
              />
            </LineChart>
          ) : (
            <BarChart data={performanceData}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis 
                dataKey="date" 
                stroke="var(--color-muted-foreground)"
                fontSize={12}
              />
              <YAxis 
                stroke="var(--color-muted-foreground)"
                fontSize={12}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="commissions" fill="var(--color-accent)" name="Commissions" />
              <Bar dataKey="bookings" fill="var(--color-success)" name="Réservations" />
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>

      <div className="flex items-center justify-center space-x-6 mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-accent rounded-full"></div>
          <span className="text-sm text-muted-foreground">Commissions</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-success rounded-full"></div>
          <span className="text-sm text-muted-foreground">Réservations</span>
        </div>
      </div>
    </div>
  );
};

export default PerformanceChart;